import ExoAvatar from '../ExoAvatar';

// the project image when it has one, otherwise the client it belongs to
const ProjectAvatar = ({ project, size = '20px' }) => {
  if (!project) return null;

  if (project.image?.temporaryUrl)
    return (
      <img
        src={project.image.temporaryUrl}
        alt=""
        className="rounded-full object-cover shrink-0"
        style={{ width: size, height: size }}
      />
    );

  const clientName = project.clientType
    ? project.clientType === 'company'
      ? project.client?.name
      : `${project.client?.lastName || ''} ${project.client?.firstName || ''}`
    : '';

  return (
    <ExoAvatar
      picture={project.client?.logo?.temporaryUrl}
      type={project.clientType}
      name={clientName}
      size={size}
    />
  );
};

export default ProjectAvatar;
